import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Create_Api_Formdata, Get_Api } from '../API_URL';
import { toast } from 'react-toastify';
import { Helmet } from "react-helmet-async";

function JobApply() {
    const { id } = useParams()

    const [AJob, setAJob] = useState(null);
    const [Isloading, setIsloading] = useState(false);

    const GetAJob = async () => {
        try {
            setIsloading(true)
            const response = await Get_Api(`api/admin/GetAjob/${id}`);
            setAJob(response?.data)
            setIsloading(false)
        } catch (error) {
            setIsloading(false)
            toast.error(error?.response?.message || "Failed to upload requirement");
            console.error("Error uploading requirement:", error);
        }
    }

    useEffect(() => {
        GetAJob();
    }, [id]);

    const [Name, setName] = useState('');
    const [Number, setNumber] = useState('');
    const [Email, setEmail] = useState('');
    const [Message, setMessage] = useState('');
    const [Resume, setResume] = useState(null);
    const [errors, setErrors] = useState({});


    const ApplyToJob = async () => {
        let newErrors = {};
        if (!Name.trim()) newErrors.Name = "Name is required";
        if (!Email.trim()) newErrors.Email = "Email is required";
        if (!Number.trim()) newErrors.Number = "Phone Number is required";
        if (!Resume) newErrors.Resume = "Resume is required";

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        const formData = new FormData();
        formData.append("Name", Name);
        formData.append("Email", Email);
        formData.append("PhoneNumber", Number);
        formData.append("Message", Message);
        formData.append("Resume", Resume);
        formData.append("Job", id);

        try {
            setIsloading(true);
            const response = await Create_Api_Formdata("api/admin/ApplytoJob", formData);

            if (response?.data) {
                toast.success("Applied Successfully! We’ll get back to you.");
                setName("");
                setEmail("");
                setNumber("");
                setMessage("");
                setResume(null);
            } else {
                toast.error(response?.message || "Failed to apply");
            }
        } catch (error) {
            console.error("Error submitting application:", error);
            toast.error(error?.response?.message || "Failed to apply");
        } finally {
            setIsloading(false);
        }
    };

    if (!AJob) {
        return <div className="text-center py-10 text-white">No job found</div>;
    };
    

    return (
        <div className="bg-[#000000] dark:bg-[#FFFFFF]">
            <Helmet>
    <title>
        {AJob?.Title
            ? `${AJob.Title} Job Opening | Apply Now | Mobikode`
            : "Job Openings at Mobikode | Apply Now"}
    </title>

    <meta
        name="description"
        content={
            AJob?.Title
                ? `Apply for the ${AJob.Title} position at Mobikode. Explore the role, required skills, responsibilities, experience, and career opportunity.`
                : "Explore current job opportunities at Mobikode and apply for technology, software development, engineering, and other open positions."
        }
    />

    <meta
        name="keywords"
        content={
            AJob?.Title
                ? `${AJob.Title} Jobs, ${AJob.Title} Job Opening, ${AJob.Title} Jobs at Mobikode, ${AJob.Title} Careers, Mobikode Careers, Mobikode Jobs, Technology Jobs, IT Jobs, Software Jobs`
                : "Mobikode Jobs, Mobikode Careers, Job Openings, IT Jobs, Technology Jobs, Software Jobs, Engineering Jobs"
        }
    />

    <link
        rel="canonical"
        href={`https://www.mobikode.com/job-apply/${id}`}
    />

    <meta
        property="og:title"
        content={
            AJob?.Title
                ? `${AJob.Title} Job Opening | Mobikode`
                : "Job Openings at Mobikode"
        }
    />

    <meta
        property="og:description"
        content={
            AJob?.Title
                ? `Explore the ${AJob.Title} opportunity at Mobikode. Check the role details, responsibilities, required skills, and apply for the position.`
                : "Explore career opportunities and current job openings at Mobikode."
        }
    />

    <meta
        property="og:url"
        content={`https://www.mobikode.com/job-apply/${id}`}
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/career/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content={
            AJob?.Title
                ? `${AJob.Title} Job Opening | Mobikode`
                : "Job Openings at Mobikode"
        }
    />

    <meta
        name="twitter:description"
        content={
            AJob?.Title
                ? `Apply for the ${AJob.Title} position at Mobikode and explore the role, skills, responsibilities, and career opportunity.`
                : "Explore current career opportunities and job openings at Mobikode."
        }
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/career/bg1.png"
    />
</Helmet>
            <div className='career-banner career-banner5 career-banner4'>
                <div className='career-banner-overlay career-banner-overlay2'>
                    <div className="max-w-[1200px] w-full mx-auto lg:px-[12px] px-[20px]">
                        <h3 style={{ textAlign: "left" }} className='font-graphik font-[400] text-[28px] lg:text-[44px]'>{AJob?.Title}</h3>
                        <p> {AJob?.Location?.City}, {AJob?.Location?.Country}</p>
                    </div>
                </div>
            </div>
            <div className="text-white dark:text-[#242424] max-w-[1200px] lg:px-[12px] pt-[80px] px-[20px] w-full mx-auto">
                <p className="text-lg mb-[20px] text-[#ED6800]"><strong>Experience:</strong> {AJob?.Experience} Years</p>

                <div className="lg:mb-[50px] mb-[30px]">
                    <h2 className="lg:text-[35px] text-[28px] font-semibold mb-2">About the Role</h2>
                    <div
                        dangerouslySetInnerHTML={{ __html: AJob?.AboutRole }}
                        className="!text-white [&_*]:!text-white dark:[&_*]:!text-[#242424]"
                    />
                </div>

                <div className="lg:mb-[50px] mb-[30px]">
                    <h2 className="lg:text-[35px] text-[28px] font-semibold mb-2">Key Responsibilities</h2>
                    <div
                        dangerouslySetInnerHTML={{ __html: AJob?.KeyResponsibilities }}
                        className="!text-white [&_*]:!text-white dark:[&_*]:!text-[#242424]"
                    />

                </div>

                <div className="lg:mb-[50px] mb-[30px]">
                    <h2 className="lg:text-[35px] text-[28px] font-semibold mb-2">Required Skills</h2>
                    <ul className="flex flex-wrap gap-[20px]">
                        {AJob?.requireSkills?.map((skill, idx) => (
                            <li className='dark:bg-[#FFFFFF] hover:scale-[1.02] transition-all duration-300 ease-in-out py-[10px] px-[20px] text-[#FFFFFF] dark:text-[#242424] dark:shadow-lg border border-[#ed67003f] hover:border-[#ED6800] bg-[#242424]' key={idx}>{skill}</li>
                        ))}
                    </ul>
                </div>

                <div className="lg:mb-[50px] mb-[30px]">
                    <h2 className="lg:text-[35px] text-[28px] font-semibold mb-2">Nice To Have Skills</h2>
                    <ul className="flex flex-wrap gap-[20px]">
                        {AJob?.niceToHaveSkills?.map((skill, idx) => (
                            <li className='dark:bg-[#FFFFFF] hover:scale-[1.02] transition-all duration-300 ease-in-out py-[10px] px-[20px] text-[#FFFFFF] dark:text-[#242424] dark:shadow-lg border border-[#ed67003f] hover:border-[#ED6800] bg-[#242424]' key={idx}>{skill}</li>
                        ))}
                    </ul>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-[30px] gap-y-[30px]">
                    {/* Name */}
                    <div className="grid gap-[14px]">
                        <label className='text-[#c1c3c7] dark:text-[#242424] text-[16px] sm:text-[18px] font-[400] leading-[24px]'>
                            Name <span className='text-[#c00d0d]'>*</span>
                        </label>
                        <input
                            value={Name}
                            onChange={(e) => setName(e.target.value)}
                            type="text"
                            placeholder='Enter your Name'
                            className={`bg-[#FFFFFF] py-[12px] px-[15px] text-[#000000] text-[16px] sm:text-[18px] font-[400] w-full 
            ${errors?.Name ? "border border-red-500" : "border border-gray-300"}`}
                        />
                        {errors?.Name && (
                            <span className="text-red-500 text-sm">{errors?.Name}</span>
                        )}
                    </div>

                    {/* Email */}
                    <div className="grid gap-[14px]">
                        <label className='text-[#c1c3c7] dark:text-[#242424] text-[16px] sm:text-[18px] font-[400] leading-[24px]'>
                            Email <span className='text-[#c00d0d]'>*</span>
                        </label>
                        <input
                            value={Email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            placeholder='Enter your email'
                            className={`bg-[#FFFFFF] py-[12px] px-[15px] text-[#000000] text-[16px] sm:text-[18px] font-[400] w-full 
            ${errors?.Email ? "border border-red-500" : "border border-gray-300"}`}
                        />
                        {errors?.Email && (
                            <span className="text-red-500 text-sm">{errors?.Email}</span>
                        )}
                    </div>

                    {/* Phone */}
                    <div className="grid gap-[14px]">
                        <label className='text-[#c1c3c7] dark:text-[#242424] text-[16px] sm:text-[18px] font-[400] leading-[24px]'>
                            Phone <span className='text-[#c00d0d]'>*</span>
                        </label>
                        <input
                            type="text"
                            value={Number}
                            onChange={(e) => setNumber(e.target.value)}
                            placeholder='Enter your Phone Number'
                            className={`bg-[#FFFFFF] py-[12px] px-[15px] text-[#000000] text-[16px] sm:text-[18px] font-[400] w-full 
            ${errors?.Number ? "border border-red-500" : "border border-gray-300"}`}
                        />
                        {errors?.Number && (
                            <span className="text-red-500 text-sm">{errors?.Number}</span>
                        )}
                    </div>

                    {/* Upload Resume */}
                    <div className="grid gap-[14px]">
                        <label className='text-[#c1c3c7] dark:text-[#242424] text-[16px] sm:text-[18px] font-[400] leading-[24px]'>
                            Upload Resume <span className='text-[#c00d0d]'>*</span>
                        </label>
                        <input
                            type="file"
                            accept=".pdf,.doc,.docx"
                            onChange={(e) => setResume(e.target.files[0])}
                            style={{ border: 'none' }}
                            className={`text-[#fff] dark:text-[#242424] text-[16px] sm:text-[18px] font-[400] w-full file:mr-4 file:py-2 file:px-4 file:border-0 file:bg-[#ed6800] file:text-white file:rounded cursor-pointer
            ${errors?.Resume ? "border border-red-500" : "border border-black-300"}`}
                        />
                        {errors?.Resume && (
                            <span className="text-red-500 text-sm">{errors?.Resume}</span>
                        )}
                    </div>

                    {/* Message (Full Width) */}
                    <div className="sm:col-span-2">
                        <div className="grid gap-[14px]">
                            <label className='text-[#c1c3c7] dark:text-[#242424] text-[16px] sm:text-[18px] font-[400] leading-[24px]'>
                                Your Message <span className='text-[#c00d0d]'>*</span>
                            </label>
                            <textarea
                                value={Message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder='What can we help you with...'
                                rows="4"
                                className='bg-[#FFFFFF] py-[12px] px-[15px] text-[#000000] text-[16px] sm:text-[18px] font-[400] w-full'
                            ></textarea>
                        </div>
                    </div>
                </div>
                <br />
                <button onClick={() => { ApplyToJob() }} style={{ border: '2px solid rgba(167, 167, 167, 0.31)' }} className=" banner-btn group border flex gap-[16px] items-center hover:border-[#ed6800] border-[#FFFFFF] font-graphik py-[14px] px-[24px] text-[#FFFFFF] dark:text-black font-[400] text-[20px] leading-[24px] bg-transparent transition-all duration-300 tracking-[1px]">
                    {Isloading ? "Please Wait" : "Apply Now"}
                    <img
                        src="/assets/tab/icon-right.svg"
                        className="h-[26px] filter invert transition-transform dark:invert-0 duration-300 group-hover:translate-x-2"
                        alt="arrow"
                    />  </button>
                {/* <button  className="bg-orange-600 hover:bg-orange-700 text-white py-3 px-6 text-lg mt-5">
                    
                </button> */}
            </div>
            <br />
            <br />
            <br />
        </div>
    )
}

export default JobApply